<template>
    <b-card no-body :border-variant="borderVariant">
        <NewSupplierModal
            ref="supplierForm"
            @saved="onSupplierCreated"
        />
        <div class="card-header supplier-selector">
            <div class="col-md-6 pl-0">
                <b-card-title>
                    {{ $t('Component(SupplierSelector):label') }}
                </b-card-title>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div :class="{'col-md-6 col-lg-8': add, 'col-md-12 col-lg-12': !add}">
                        <SupplierSearch
                            :is-supplier-selected-callback="this.isSelected"
                            @selected="this.addSupplier"
                        />
                    </div>
                    <div v-if="add" class="col-md-2 col-lg-1 d-flex align-items-center justify-content-center">
                        {{ $t('Component(Text):or') }}
                    </div>
                    <div v-if="add" class="col-md-4 col-lg-3 d-flex justify-content-end align-items-center mr-0 pr-0">
                        <b-button
                            class="d-inline-block w-100"
                            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                            variant="primary"
                            @click="showNewSupplierForm"
                        >
                            {{ addButtonLabel || $t('Component(Button):add') }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <slot name="under-heading" />
        <Transition mode="out-in" name="fade">
            <b-alert
                variant="secondary"
                show
                class="m-2"
                v-if="suppliers.length === 0"
            >
                <div class="alert-body">
                    <span>{{ $t('Component(SupplierSelector):empty-description') }}</span>
                </div>
            </b-alert>
            <b-table
                :fields="fields"
                :items="suppliers"
                v-if="suppliers.length"
                responsive
            >
                <template #cell(id)="data">
                    <LegalIdentity
                        :view="true"
                        :identity="data.item.legalIdentity"
                    />
                </template>
                <!-- A custom formatted column -->
                <template #cell(name)="data">
                    {{ data.item.title }}
                </template>

                <template #cell(location)="data">
                    {{ data.item.state.title }}
                </template>
                <template #cell(contactName)="data">
                    {{ data.item.contact.name }}
                </template>
                <template #cell(contactEmail)="data">
                    {{ data.item.contact
                    ? data.item.contact.email
                    : '' }}
                </template>
                <!-- Optional default data cell scoped slot -->
                <template #cell()="data">
                    {{ data.value }}
                </template>
            </b-table>
        </Transition>
        <slot
            name="after-selection"
            :suppliers="suppliers"
        />
    </b-card>
</template>
<script>
import {
    BTable, BCardTitle, BCard, BButton,
    BBadge, BAlert, BFormGroup
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'
import SupplierSearch from "@core/components/supply-chain/SupplierSearch";
import NewSupplierModal from "@core/components/supply-chain/NewSupplierModal";
import LegalIdentity from "@core/components/common/LegalIdentity.vue";

export default {
    components: {
        LegalIdentity,
        BTable,
        BBadge,
        BFormGroup,
        VueAutosuggest,
        BAlert,
        BCard,
        BCardTitle,
        BButton,
        NewSupplierModal,
        SupplierSearch,
    },
    directives: {
        Ripple,
    },
    props: {
        addButtonLabel: {
            type: String,
            default: null,
        },
        borderVariant: {
            default: 'light'
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        },
        add: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            fields: [
                { key: 'name', label: this.$t('Component(SupplierSelector):field-name') },
                { key: 'id', label: this.$t('Component(SupplierSelector):field-legal-identity') },
                { key: 'location', label: this.$t('Component(SupplierSelector):field-location') },
                { key: 'contactName', label: this.$t('Component(SupplierSelector):field-contact-name') },
                { key: 'contactEmail', label: this.$t('Component(SupplierSelector):field-contact-email') },
            ],

            suppliers: this.selected,
            state: null,
        };
    },
    methods: {
        isSelected(suggestion) {
            return this.suppliers.find(s => s.id === suggestion.item.id);
        },
        onSupplierCreated(supplier) {
            this.addSupplier(supplier);
        },
        addSupplier(supplier) {
            if (this.suppliers.length) {
                let exists = this.suppliers.find(s => s.id === supplier.id);
                if (exists) {
                    return;
                }

                this.suppliers = [];
            }
            this.suppliers.push(supplier);
            this.$emit('change', this.suppliers.map(s => s.id), this.suppliers);
        },
        showNewSupplierForm() {
            this.$refs['supplierForm'].showModal();
        },
    },
    watch: {
        selected(value) {
            this.suppliers = value;
        }
    }
}
</script>
<style lang="scss">
.supplier-selector {
    .control-elements {
        display: flex;
    }
}
</style>
